<template>
  <el-dialog
    :title="title"
    :visible.sync="templeShowDialog"
    center
    width="60%"
    style="height:500px,max-height:500px;"
    @closed="closeDialog"
  >
    <vxe-table
      ref="water_xTable"
      :data="tableData"
      max-height="430px"
      min-height="230px"
      border
      align="center"
      :span-method="spanMethods"
      header-align="center"
    >
      <vxe-table-column
        v-for="(item, index) in tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
      >
        <template v-slot="{ row }">
          <template v-if="item.field == 'leaseDateFrom'"
            ><div>
              {{ row['leaseDateFrom'] + ' - ' + row['leaseDateUntil'] }}
            </div></template
          >
          <template v-else>{{ row[item.field] }}</template>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog" plain>关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    name: 'SpaceInfoDialog',
    data() {
      return {
        templeShowDialog: this.showDialog,
        // dialogTitle:this.title,
        // dialogTableData:this.tableData
      };
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      tableData: {
        type: Array,
        default: () => [],
      },
      title: {
        type: String,
        default: '',
      },
    },
    computed: {
      tableColumn() {
        let arr = [
          {
            field: 'spaceName',
            title: '空间名称',
            visible: true,
          },
          {
            field: 'spaceArea',
            title: '面积（㎡）',
            visible: true,
          },
        ];
        if (this.title == '已出租') {
          arr.push(
            {
              field: 'contractNo',
              title: '合同编号',
              visible: true,
            },
            {
              field: 'customerName',
              title: '客户名称',
              visible: true,
            },
            {
              field: 'leaseDateFrom',
              title: '租赁期限',
              visible: true,
            }
          );
        } else if (this.title == '已失效') {
          arr.push({
            field: 'expiredDate',
            title: '失效时间',
            visible: true,
          });
        }
        return arr;
      },
    },
    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
      // tableData(var1, var2) {
      //   this.dialogTableData = var2;
      //   this.dialogTableData = var1;
      // },
      // title(var1, var2) {
      //   this.dialogTitle = var2;
      //   this.dialogTitle = var1;
      // },
    },
    methods: {
      spanMethods({ row, $rowIndex, column, data }) {
        let fields = ['spaceName', 'spaceArea'];
        let cellValue = row[column.property];
        if (cellValue && fields.includes(column.property) && this.title == '已出租') {
          let prevRow = data[$rowIndex - 1];
          let nextRow = data[$rowIndex + 1];
          if (prevRow && prevRow[column.property] === cellValue) {
            return { rowspan: 0, colspan: 0 };
          } else {
            let countRowspan = 1;
            while (nextRow && nextRow[column.property] === cellValue) {
              nextRow = data[++countRowspan + $rowIndex];
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 };
            }
          }
        }
      },
      // 关闭弹窗
      closeDialog() {
        this.$emit('closeDialog', false);
      },
    },
  };
</script>
